import { lang } from 'moment';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex); 
export default new Vuex.Store({
	state:{//定义状态
	    bgimgCode:['1.jpg','2.jpg','3.jpg','4.jpg','5.jpg'],
		ifyBody:{//查询分类
					 Type:"aid",//类型
					 Address:"address",//出版地址
					 Cdgb:"cdgb2",//朝代/国别
					 Organ:"book_organ",//出版机构
					 Publisher:"book_publisher"//出版人
		},
		bindexTypes:[ {//子目检索下拉框内容
		  "code": "TI",
		  "name": "标题",
		  "L_name": "標題"
		},
		{
		  "code": "AU",
		  "name": "著者",
		  "L_name": "著者"
		}], 
		searchTypes:[//作品检索下拉框内容
		  {
		    "code": "ALL",
		    "name": "全部",
		    "L_name": "全部"
		  },
		  {
		    "code": "TI",
		    "name": "标题",
		    "L_name": "標題"
		  },
		  {
		    "code": "AU",
		    "name": "著者",
		    "L_name": "著者"
		  },
		  {
		    "code": "KW",
		    "name": "关键词",
		    "L_name": "關鍵詞"
		  },
		  {
		    "code": "NT",
		    "name": "附注信息",
		    "L_name": "附註信息"
		  },
		  {
		    "code": "BI",
		    "name": "内容简介",
		    "L_name": "附註信息"
		  }
		],
		
		ifyRemoveNav:["aid","bid","cid","did","eid"],//类型分类查询顺序
		filedTypes:[//检索范围
			
		  {
		    "code": "all",
		    "name": "全库",
		    "L_name": "全庫",
			"Checked":true
		  },
		  {
		    "code": "book",
		    "name": "古籍",
		    "L_name": "古籍",
			"Checked":true
		  },
		  {
		    "code": "perss",
		    "name": "报刊",
		    "L_name": "報刊",
			"Checked":true
		  },
		  {
		    "code": "school",
		    "name": "图书",
		    "L_name": "圖書",
			"Checked":true
		  },
		  {
		    "code": "map",
		    "name": "地图",
		    "L_name": "地圖",
			"Checked":true
		  },
		  {
		    "code": "img",
		    "name": "美术",
		    "L_name": "美術",
			"Checked":true
		  } ,
		  {
		    "code": "music",
		    "name": "音乐",
		    "L_name": "音樂",
			"Checked":true
		  }
		],
		sjkList: [{"code":"book","name":["古籍文献","古籍文獻"]},{"code":"perss","name":["近代报刊","近代報刊"]},
						  {"code":"school","name":["民国图书","民國圖書"]},{"code":"map","name":["古地图","古地圖"]},
						  {"code":"img","name":["美术作品","美術作品"]},
						  {"code":"madia","name":["电影作品","電影作品"]},
						  {"code":"music","name":["音乐作品","音樂作品"]}], 
		bindexTypes:[{
				   "code": "TI",
				   "name": "标题",
				   "L_name": "標題"
				 },
		{
		  "code": "AU",
		  "name": "著者",
		  "L_name": "著者"
		}],
		advSTypes:[{code:"TI",L_name:"標題",name:"标题"},{code:"AU",L_name:"著者",name:"著者"},{code:"CD",L_name:"朝代/國別",name:"朝代/国别"},{code:"TM",L_name:"創建日期",name:"创建日期"},
		             {code:"FC",L_name:"創建人/機構",name:"创建人/机构"},{code:"PC",L_name:"創建地點",name:"创建地点"},{code:"ED",L_name:"版本",name:"版本"},{code:"SB",L_name:"叢書",name:"丛书"},
		             {code:"KW",L_name:"關鍵詞",name:"关键词"},{code:"NT",L_name:"附註信息",name:"附注信息"},
							  {code:"BT",L_name:"內容簡介",name:"内容简介"}],
							  autherSTypes:[{code:"TI",L_name:"姓名",name:"姓名"},
							  {code:"AD",L_name:"籍贯/出生地",name:"籍贯/出生地"},
							  {code:"CD",L_name:"朝代/國別",name:"朝代/国别"},{code:"BR",L_name:"生年",name:"生年"},
							  {code:"DE",L_name:"卒年",name:"卒年"},{code:"IN",L_name:"人物簡介",name:"人物简介"}],//检索下拉框数据选择
							  
	},
	mutations:{//方法
	
	},
	actions:{//异步操作
		
	},
	getters:{//定义计算属性
		
	},
	
	
	  
})